import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ProfessionalLayout } from './ProfessionalLayout';

interface Props {
  resume: BuiltResume;
}

export function PrintLayout({ resume }: Props) {
  return (
    <div className="resume-print-wrapper">
      <ProfessionalLayout resume={resume} />
    </div>
  );
}
